import { Box, Skeleton } from '@hopskipdrive/react-components';

export const RiderInfoContainer = ({ isFetching, children }) => {
  if (!isFetching && !children) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="row" alignItems="center" gap="9px">
      {isFetching ? (
        <>
          <Skeleton data-testid="rider-info-skeleton-loader" variant="circular" width={24} height={24} />
          <Skeleton variant="text" width={139} height={32} />
          <Skeleton variant="circular" width={24} height={24} />
        </>
      ) : (
        children
      )}
    </Box>
  );
};
